import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCheckCircle, FiPlus, FiMoon, FiSun, FiDownload } = FiIcons;

const Header = ({ darkMode, setDarkMode, onNewChecklist }) => {
  const location = useLocation();

  return (
    <header className={`border-b transition-colors duration-300 ${
      darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'
    }`}>
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-3">
            <SafeIcon icon={FiCheckCircle} className="text-2xl text-blue-600" />
            <div>
              <h1 className="text-xl font-bold font-inter">N1P Checklist</h1>
              <p className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                Gerador de Marcos de Progresso
              </p>
            </div>
          </Link>

          <nav className="flex items-center space-x-4">
            <Link
              to="/"
              className={`px-4 py-2 rounded-lg transition-colors ${
                location.pathname === '/' 
                  ? 'bg-blue-600 text-white' 
                  : darkMode 
                    ? 'text-gray-300 hover:text-white hover:bg-gray-700' 
                    : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
              }`}
            >
              Editor
            </Link>
            <Link
              to="/import-export"
              className={`px-4 py-2 rounded-lg transition-colors flex items-center space-x-2 ${
                location.pathname === '/import-export' 
                  ? 'bg-blue-600 text-white' 
                  : darkMode 
                    ? 'text-gray-300 hover:text-white hover:bg-gray-700' 
                    : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
              }`}
            >
              <SafeIcon icon={FiDownload} />
              <span>Import/Export</span>
            </Link>
            
            <button
              onClick={onNewChecklist}
              className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg transition-colors flex items-center space-x-2"
            >
              <SafeIcon icon={FiPlus} />
              <span>Nova Lista</span>
            </button>
            
            <button
              onClick={() => setDarkMode(!darkMode)}
              className={`p-2 rounded-lg transition-colors ${
                darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-100'
              }`}
            >
              <SafeIcon icon={darkMode ? FiSun : FiMoon} />
            </button>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;